import { signOut } from 'aws-amplify/auth'
import { clearStorage } from './clear_storage'
import { clearLocalStorage, getLocalStorage } from './storage_helpers'
import { addLocalStorage } from '../../infra/storage/localStorage'

export async function logOut () {
  const saveSupport = getLocalStorage('support')
  const saveLanguage = getLocalStorage('gameLanguage')

  try {
    await signOut({ global: true })

    clearStorage()
    clearLocalStorage()

    addLocalStorage('support', saveSupport)
    addLocalStorage('gameLanguage', saveLanguage)

    window.location.href = '/login'
  } catch (error) {
    console.error('Error during sign out:', error)

    clearStorage()
    clearLocalStorage()
    addLocalStorage('support', saveSupport)
    addLocalStorage('gameLanguage', saveLanguage)
    window.location.href = '/login'
  }
}
